import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PutAttachmentFormFields {


    constructor() {


    }
}

const fields = new PutAttachmentFormFields()

export const putAttachmentFormFieldOptions: {[key: string]: FormField} = {
};